import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

// MUI Components
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// Components
import AlertModal from './alert-modal';

const BulkActionsMenu = ({ selectedSites = [], getSites, clearSelection }) => {

    const [ anchorEl, setAnchorEl ]                 = useState(null);
    const open                                      = Boolean(anchorEl);

    const [ alertModalOpen, setAlertModalOpen ]     = useState(false);
    const [ allSitesNotice, setAllSitesNotice ]     = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const runAction = (action) => {
        setAnchorEl(null);
        if( selectedSites.length === 0 ){
            toast.error('No sites selected');
            return;
        }
        axios.post('/sites/bulk-action', {
            ids: selectedSites,
            action: action
        }).then(response => {
            if( response.status === 200 && !response.data.error ){
                toast.success(response.data.message);
                clearSelection();
                getSites();
            }
        });
    }

    const setCrawlable = (crawlable) => {
        runAction(crawlable ? 'make-crawlable' : 'make-non-crawlable');
    }

    const setClearLogs = () => {
        runAction('clear-logs');
    }

    const updatePlugins = () => {
        runAction('update-plugin');
    }

    const triggerAlert = () => {
        setAnchorEl(null);
        if( selectedSites.length === 0 ){
            toast.error('No sites selected');
            return;
        }
        setAllSitesNotice(false);
        setAlertModalOpen(true);
    }

    const triggerAllSitesNotice = () => {
        setAnchorEl(null);
        setAllSitesNotice(true);
        setAlertModalOpen(true);
    }
    
    return (
        <>
            <Button variant='contained' color='primary' onClick={handleClick}>
                Bulk Action
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => triggerAlert()}>
                    Send Alert
                </MenuItem>
                <MenuItem onClick={() => triggerAllSitesNotice()}>
                    Create Global Notice
                </MenuItem>
                <MenuItem onClick={() => setCrawlable(true)}>
                    Make Crawlable
                </MenuItem>
                <MenuItem onClick={() => setCrawlable(false)}>
                    Make Non-Crawlable
                </MenuItem>
                <MenuItem onClick={() => setClearLogs(true)}>
                    Clear Logs
                </MenuItem>
                <MenuItem onClick={() => updatePlugins()}>
                    Update Plugin
                </MenuItem>
            </Menu>
            <AlertModal
                open={alertModalOpen}
                setOpen={setAlertModalOpen}
                selectedSites={selectedSites}
                allSites={allSitesNotice}
            />
        </>
    )

}

export default BulkActionsMenu;